import './class-component-hooks';
import Vue from 'vue';
import 'core-js';
import './assets/stylesheets/app.styl';
import './assets/stylesheets/theme.styl';
import './assets/styles/main.scss';
// import initSentry from './sentry';
import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next';
import locales from '../locales/common';
import App from './App.vue';
import GeneralProblem from '@/views/GeneralProblem.vue';
import vuex from './store';
import router from './router';
import Vuetify from 'vuetify';
import VuetifyConfirm from 'vuetify-confirm';
import Notifications from 'vue-notification';
import './resizer';
import 'vuetify/dist/vuetify.min.css';
import moment from 'moment-timezone';
import Utils from './modules/Utils';

Vue.use(Notifications);
Vue.use(VuetifyConfirm);
// @ts-ignore
const { lang } = vuex.state.Global;

Vue.use(Vuetify, {
  rtl: lang !== 'en'
});

Vue.use(VueI18Next);

Vue.config.productionTip = false;

Vue.config.errorHandler = (err, vm, info) => {
  if (process.env.NODE_ENV === 'develop') {
    console.error('Vue error:', err);
    console.log('Component:', vm);
    console.log('Error info:', info);
  }
};

i18next.init({
  lng: lang,
  fallbackLng: 'en',
  resources: {
    en: { translation: locales.en },
    he: { translation: locales.he }
  }
});

Vue.prototype.$handler = () => {
  const difference_in_minutes = Utils.getIdleTimeInMinutes();
  
  if (difference_in_minutes >= 90) {
    vuex.dispatch('User/logout');
    vuex.commit('User/setIntervalActive', false);
  }else {
    localStorage.setItem('last_time_seen', moment().utcOffset(0).valueOf().toString());
  }
};

export const i18n = new VueI18Next(i18next);

// Declare global dataLayer property for Google Analytics
declare global {
  interface Window {
    dataLayer: any[];
    gtag?: (...args: any[]) => void;
  }
}

// Function to initialize Google Analytics only in non-development environments
function initGoogleAnalytics() {
  if (process.env.NODE_ENV !== 'develop') {
    // Dynamically add the Google Analytics script tag
    const gaScript = document.createElement('script');
    gaScript.async = true;
    gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-NZTQK0X9SY';
    document.head.appendChild(gaScript);
    
    // Google Analytics initialization
    window.dataLayer = window.dataLayer || [];
    function gtag(...args: any[]) {
      window.dataLayer.push(args);
    }
    gtag('js', new Date());
    gtag('config', 'G-NZTQK0X9SY');
    gtag('event', 'session_start', {
      dashboard_version: process.env.VUE_APP_VERSION || '0.0.0'
    });
  } else {
    console.info("Google Analytics disabled in development mode");
  }
}

const maintenance_json = async () => {
  // Initialize Sentry before creating Vue instance
  // initSentry();
  initGoogleAnalytics();
  
  try {
    const response = await fetch(`.well-known/maintenance.json`);
    const general_problem = await response.json();
    if (general_problem && general_problem.hasOwnProperty('killswitch') && general_problem.killswitch){
      new Vue({
        router,
        i18n,
        store: vuex,
        render: (h) => h(GeneralProblem)
      }).$mount('#app');
    }else {
      vuex.dispatch('Global/init').then(() => {
        new Vue({
          router,
          i18n,
          store: vuex,
          render: (h) => h(App)
        }).$mount('#app');
      });
    }
  }catch (e) {
    vuex.dispatch('Global/init').then(() => {
      new Vue({
        router,
        i18n,
        store: vuex,
        render: (h) => h(App)
      }).$mount('#app');
    });
  }
};

maintenance_json();
